module.exports = __webpack_public_path__ + "img/price-strategy.58904a28.png";